export default __webpack_public_path__ + "static/media/zine-itch-article3.112c9f89.png";